import Image from 'next/image';
import React from 'react';

const Lms: React.FC = () => {
    return (
        <div className='wrapper max-w-10xl bg-white'>
            <div className='
                max-w-7xl mx-auto p-6 bg-white shadow-md rounded-lg
                2xl:max-w-2xl
                lg:max-w-lg
                md:max-w-md
                sm:max-w-sm
            '>
                <h1 className='text-9px sm:text-sm md:text-base lg:text-lg xl:text-xl bg-[#6796bf] text-white text-center mt-10 mb-14 whitespace-nowrap'>
                    <div className='p-10'>
                        Ultra 경험(Learn Ultra)이 포함된 Blackboard Learn™은 <br />
                        더 간단하고 강력한 교수학습 경험을 제공합니다.<br /><br />
                        현대적이고 직관적이며 완벽하게 반응하는 <br />
                        인터페이스를 갖춘 Learn Ultra는 학생들의 참여도를 높이고<br />
                        교육자의 부담을 덜어주며 성공의 길을 열어줍니다.<br />
                    </div>
                </h1>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-course'></div>
                    <h2 className='text-base h-14 text-left p-4 border-gray-600 pr-16'>
                        유연한 코스 설계
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>
                
                
                <h2 className='text-xl font-semibold mb-2 mt-14'>다양한 교수학습에 효과적인 플랫폼</h2>
                <div>블랙보드는 대학 및 유관 기관의 오프라인, 온라인, 블렌디드 강의, PBL 등 다양한 교수학습법을 지원합니다. 교수법, 학습활동, 커뮤니케이션, 컨텐트 유형, 시간(주차) 등 코스가 어떤 부분에 포커스를 두는가에 따라 다양하게 메뉴를 구성할 수 있으며, 메뉴 내에 콘텐츠도 유형에 관계 없이 유연하게 배치할 수 있기 때문입니다.</div>

                <h2 className='text-xl font-semibold mt-6  mb-2'>개인별 맞춤학습/진도관리</h2>
                <div>다양한 학생의 수준과 성향을 고려한 학생 중심의 학습(Student-Centered Learning)이 가능하도록 하기 위해서는 학생 개인별 맞춤학습과
                <br></br> 진도관리가 필요합니다.​<br></br><br></br>
                학생의 학습스타일과 성적, 진도에 따라 그룹별 또는 개인별로 다양한 학습경로를 제공하여 맞춤학습을 설정합니다. 미리 설정해 놓은 콘텐츠는 언제 어느 학생에게 보여줄지 조절할 수 있기 때문에 학생의 학습상태에 따라 보여지는 내용도 달라집니다. 특정 기간에만 학습을 하게 하거나, 그룹별로 다른 내용의 학습을 하게 하거나, 기준 성적에 도달하거나 특정 콘텐츠를 학습해야 다음단계로 넘어가도록 설정할 수 있습니다.</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-learning'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                        협업 학습
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <h2 className='text-xl font-semibold mb-2  mt-14'>그룹/팀 프로젝트​</h2>
                
                <div>그룹활동은 결과물도 중요하지만 처음에 그룹을 만드는 것부터 시작하여, 그룹활동의 과정에서 팀원들이 얼만큼 자신의 역할을 잘 수행하고 서로 협업하였는지 등의 팀워크도 중요한 평가요소입니다. 블랙보드에서는 자가등록, 지정등록 등 그룹을 나누는 방법부터 다양하게 시도해 볼 수 있습니다. ​
                <br></br>그룹이 만들어지면, 해당 그룹만의 공간이 생기고 여기에서 그룹 내에서만 공유되는 콘텐츠를 올려 공유하고, 도구(토론방, 블로그, 위키 등)를 사용하여 활발한 커뮤니케이션을 해가며 과제물을 준비하게 됩니다. 교수자는 이러한 활동과정을 모니터링하고, 그룹별 점수나 개인별 기여도에 따라 점수를 매깁니다.</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-management'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                        학습 평가 관리
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <h2 className='text-xl font-semibold mb-2 mt-14 '>편리한 종합 성적관리센터​</h2>
                <div>블랙보드는 세밀하고 다면적 평가관리가 가능한 강력한 기능들을 제공합니다. 코스 내 채점이 필요한 모든 과제들은 성적관리센터에 모아지고, 엑셀처럼 유연하게 수정하면서 사용할 수 있습니다. 교수자가 별도로 엑셀을 사용하여 학생들의 개별 학습활동을 채점하고 관리하는 것을 블랙보드 성적센터에서 보다 편리하고 세밀하게 성적채점과 관리를 하도록 합니다.​
                <br></br>과제물 채점, 학습 참여도 채점, 퀴즈/시험 채점 뿐 아니라 외부성적 컬럼을 추가(출결점수, 행사참여 점수관리 등)할 수 있어, 유연하게 전체적인 성적관리를 지원합니다. 특정 학생의 전체 학습활동 내역을 한눈에 파악할 수 있도록 통계수치를 보여주기 때문에 직관적이고 공정한 평가를 위한 풍부한 기능을 제공합니다.</div>

                <h2 className='text-xl font-semibold mt-6 mb-2'>자기평가/동료평가 지원 </h2>
                <div>선진 교육기관은 종이 없는 캠퍼스를 구현하기 위해 블랙보드 플랫폼을 활용한 평가를 확대하고 있으며, 블랙보드는 평가 부문의 개발에 많은 투자를 합니다.​
                <br></br>교수자 개별 또는 타 교수자와 공동으로 문제은행을 만들어 공유하거나, 글로벌 교재출판사가 제공하는 교재의 문제은행을 불러와 코스 내에서 특정 주차 또는 단원에서 활용이 가능합니다.​
                <br></br>블랙보드는 17가지 문제유형과 다양한 옵션을 제공합니다. 시험출제와 동일한 방식으로 설문조사지를 작성하여 언제든지 간편하게 실시할 수 있어, 학생들의 피드백을 빠르게 분석하여 지속적으로 블랙보드 코스에 반영하여 코스의 품질을 향상시킬 수 있습니다.</div>

                <h2 className='text-xl font-semibold mt-6 mb-2'>인터랙티브 루브릭 (다면평가표)​</h2>
                <div>채점 시, 평가기준으로 루브릭(Rubric)을 활용합니다. 마감일 준수여부, 지시사항 충족도, 창의성, 논리성 등 과제마다 평가기준도 다양합니다. 내장된 샘플 루브릭을 조금 변경하여 활용할 수 있습니다. 채점시, 루브릭을 불러와 해당 평가기준 별 학생의 성취도에 따라 클릭만 하면 자동으로 전체점수가 합산됩니다. 공정하고 객관적인 평가는 물론 각종 인증프로그램에 준하는 평가를 편리하게 수행할 수 있습니다.​</div>

                <h2 className='text-xl font-semibold mt-6 mb-2'>표절검사 시스템 – 창의성 교육과 공정평가를 지원</h2>
                <div>블랙보드는 표절검사 솔루션 SafeAssign을 고객들에게 무료로 제공합니다. SafeAssign은 웹 서비스 형태로 표절검사를 지원하는 서비스입니다. SafeAssign 은 전세계 교육기관에서 제출한 방대한 과제물과 연구논문을 수집한 저장소를 구축하여 강력한 표본 데이터베이스를 자랑합니다. 본 서비스는 Microsoft Word, PDF 등 표준 문서의 표절검사를 지원하며 한글 내용 또한 비교 검사가 가능합니다.</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-bedge'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                        배지와 수료증
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <h2 className='text-xl font-semibold mb-2 mt-14'>인증/배지​</h2>
                <div>블랙보드 코스에서는 학생의 학업 성취도에 따른 인증규칙을 충족하면 배지나 수료증을 발급할 수 있습니다.​
                <br></br>블랙보드 상에서 발급하는 디지털 뱃지는 특정 교육목표에 부합하는 학업을 완료하였음을 인증하는 디지털 파일 형태로 제공되며, 인증발행자의 정보 및 디지털 서명이 포함됩니다. 때문에 다른 사용자가 복사하거나 사용할 수 없습니다.</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-agency'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                        기관 관리
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <h2 className='text-xl font-semibold mt-14 mb-2'>멀티캠퍼스, 멀티기관(학부, 대학원, 평생교육원 등) 운영 환경 제공​</h2>
                <div>기관의 정의에 따라 시스템 관리 모델을 제공합니다. 도메인, 브랜딩, 기관별 계층구조 등으로 독립적인 운영이 가능합니다. 각 기관(학부, 대학원, 평생교육원, 유관기관 등)별로 브랜딩 및 로그인 페이지를 디자인하고, 로그인 후에도 각 역할별로 탭이나 모듈을 설정할 수 있습니다.</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-security'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                       보안 및 표준성
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <h2 className='text-xl font-semibold mt-14 mb-2'>보안성​</h2><br></br>
                <div>Blackboard의 소프트웨어 개발 모든 단계에 다음과 같은 기관의 가이드라인을 준수합니다. ​<br></br>

                <br></br>National Institute of Standards and Technology (NIST)​<br></br>

                <br></br>European Network and Information Security Agency (ENISA)​<br></br>

                <br></br>SANS Institute​<br></br>

                <br></br>Open Web Application Security Project (OWASP)​<br></br>

                <br></br>Cloud Security Alliance (CSA)</div><br></br>

                <div className='flex justify-between items-start space-x-10 mt-2'>
                    <div className='flex-1'>
                    <h2 className='text-xl font-semibold mb-2 border border-black rounded-md p-2'>웹 접근성</h2>
                        <div>
                        W3C에 의한 Web Content Accessibility (WCAG) Guidelines 2.0 Level AA 에 의거하여 설계/개발되었고, 제3자 업체에 의한 정기적인 감사를 진행합니다.
                        </div>
                    </div>

                    <div className='flex-1'>
                    <h2 className='text-xl font-semibold mb-2 border border-black rounded-md p-2'>크로스 브라우저 지원</h2>
                        <div>
                        새로운 버전의 브라우저가 릴리즈 되기 전, 각 릴리즈 채널을 통해 직접 테스트 후 새로운 버전을 릴리즈할 수 있도록 합니다.
                        </div>
                    </div>
                </div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-mobile'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                       모바일 환경 지원
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>
            
                <h2 className='text-xl font-semibold mt-14 mb-2 '>Blackboard Mobile​</h2>
                <div>다양한 모바일 디바이스 지원​

                블랙보드는 역할에 따라(예:교수, 학생) 다른 앱을 제공합니다. 반응형 웹 기반의 모바일 브라우저 를 통한 웹 접근 뿐만 아니라, 모바일 기기의 특성을 직관적으로 활용하는 네이티브 모바일 런 앱을 제공해 웹 상의 블랙보드 기능을 동시에 수행합니다. ​

                블랙보드 모바일 솔루션은 중앙 서비스 아키텍처를 지원하여, 대학이 기술 유지보수 및 운영지원의 부담을 해소하고 별도의 시스템 환경을 구축할 필요가 없이 교육에 자원을 집중하도록 합니다. ​</div>

                <div className='relative flex items-center bg-[rgba(76,131,191,0.5)] h-14 p-4 border-b-2 border mt-14'>
                    <div className='fa-fas-mobile'></div>
                    <h2 className='text-base h-14 text-left p-4  border-gray-600 pr-16'>
                       실시간 화상 강의
                    </h2>
                    <span className='hidden md:block absolute right-0 left-1/3 top-1/2 transform -translate-y-1/2 border-t-2 border-#ffffff-600'></span>
                </div>

                <div className='flex flex-col lg:flex-row items-center mt-12'>
                    <div className='flex-1 lg:pr-8'>
                        <h2 className='text-xl font-semibold mb-2'>Blackboard Collaborate​</h2>
                        <div className='text-sm'>
                            <div>
                                Blackboard Collaborate 는 교직원들의 가상 오피스, 미팅룸, 웹세미나, 온라인 강의, 원격 강의, 원격 지원 등 다양한 방식으로 활용될 수 있는 웹 컨퍼런싱 툴입니다. webRTC 기술을 이용한 웹기반 실시간 강의 도구인 Blackboard Collaborate를 사용하여 온라인상에서 오프라인처럼 강의 및 발표를 하고, 토론을 하는 등의 상호작용을 할 수 있습니다.​<br/><br/>
                                데스크탑/어플리케이션 공유, 간단한 설문조사/퀴즈, 분반, 채팅, 레코딩 등의 기능을 활용하여 세션을 진행할 수 있습니다. 실시간으로 진행되는 세션은 녹화를 하여 후에 코스나 이메일로 배포할 수 있습니다.​<br/><br/><br/>
                                블랙보드와 표준 통합되어 사용자들은 별도의 원격강의실의 구축 필요없이 자신의 PC에서 블랙보드의 주어진 코스나 커뮤니티에서 링크를 클릭하여 곧바로 가상 강의실로 입장할 수 있습니다​.
                            </div>
                        </div>
                    </div>
                    <div className='flex-1 mt-8 lg:mt-0'>
                        <Image
                            src="/contents/image/collaborate.png"
                            className="w-full h-auto object-cover rounded-lg shadow-md"
                            alt="Blackboard Collaborate"
                            width={1200}
                            height={1200}
                        />
                    </div>
                </div>
            <div className='text-center mt-14 mb-2'>
                <h2 className='text-3xl font-semibold'>
                    Blackboard 제품군 플랫폼의 진정한 가치
                </h2>
                <div className='flex justify-center mt-4 mb-10'>
                    <div className='border-b-2 border-blue-600 w-10 mx-2'></div>
                    <div className='border-b-2 border-blue-600 w-2 '></div>
                </div>
            </div>
            <div className="flex flex-wrap ">
            <div className="flex flex-wrap justify-center -mx-4 mb-10">
                <div className="w-64 p-4 border rounded-lg mx-3 h-80 bg-#ffffff-100 border-#6a6a70-300 mb-4">
                <div className='fa-fas-user mb-10'></div>
                    모든 플랫폼 기반 솔루션에서 일관되고 개인화된 경험을 제공합니다.
                </div>
                <div className="w-64 p-4 border rounded-lg mx-3 h-80 bg-#ffffff-100 border-#6a6a70-300 mb-4">
                <div className='fa-fas-database mb-10'></div>
                    분석을 위한 &apos;Single Source of Truth&apos;는 데이터로 운영 및 의사 결정을 촉진하는 능력을 가속화 합니다.
                </div>
                <div className="w-64 p-4 border rounded-lg mx-3 h-80 bg-#ffffff-100 border-#6a6a70-300 mb-4">
                <div className='fa-fas-turnOn mb-10'></div>
                    REST API는 모든 클라이언트 기술에서 활용될 수 있으므로 사용자 장치의 혁신에 대한 미래 대비책입니다.
                </div>
                <div className="w-64 p-4 border rounded-lg mx-3 h-80 bg-#ffffff-100 border-#6a6a70-300 mb-4">
                <div className='fa-fas-skill mb-10'></div>
                    보다 안전하고 탄력적이며 확장가능한 성능 및 사용자 경험을 제공합니다.
                </div>
            </div>

        </div>
        </div>
    </div>

    );
}

export default Lms;



